if (!customElements.get('quick-add-modal')) {
  customElements.define(
    'quick-add-modal',
    class QuickAddModal extends ModalDialog {
      constructor() {
        super();
        this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');

        this.addEventListener('product-info:loaded', ({ target }) => {
          target.addPreProcessCallback(this.preprocessHTML.bind(this));
        });

        /* Ao abrir a lista de patches, o conteudo cresce e empurra os botoes
           pra baixo. Como a coluna tem altura limitada, isso vira rolagem e o
           card de patches ficava cortado pela metade. Aqui a gente rola o
           painel ate ele assim que a animacao de abertura termina. Escopado ao
           modal: o widget da pagina de produto nao e afetado. */
        this.addEventListener('click', (event) => {
          const trigger = event.target.closest && event.target.closest('.cdr-patches-trigger');
          if (!trigger) return;
          const widget = trigger.closest('.cdr-patches-widget');
          if (!widget) return;
          const painel = widget.closest('.product__info-wrapper');
          setTimeout(() => {
            if (!widget.classList.contains('is-open') || !painel) return;
            painel.scrollTo({ top: Math.max(0, widget.offsetTop - 8), behavior: 'smooth' });
          }, 330);
        });
      }

      hide(preventFocus = false) {
        const cartNotification = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        if (cartNotification) cartNotification.setActiveElement(this.openedBy);

        // devolve o "See details" pro lugar de origem, senao ele seria
        // apagado junto com o conteudo e sumiria na proxima abertura
        const linkDetalhes = this.modalContent.querySelector('.cdr-quick-view-details-link');
        if (linkDetalhes && this.linkDetalhesPaiOriginal) {
          this.linkDetalhesPaiOriginal.appendChild(linkDetalhes);
        }

        this.modalContent.innerHTML = '';

        if (preventFocus) this.openedBy = null;
        super.hide();
      }

      show(opener) {
        opener.setAttribute('aria-disabled', true);
        opener.classList.add('loading');
        const spinner = opener.querySelector('.loading__spinner');
        if (spinner) spinner.classList.remove('hidden');

        fetch(opener.getAttribute('data-product-url'))
          .then((response) => response.text())
          .then((responseText) => {
            const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
            const productElement = responseHTML.querySelector('product-info');

            this.preprocessHTML(productElement);
            HTMLUpdateUtility.setInnerHTML(this.modalContent, productElement.outerHTML);

            /* Coloca o "See details" DENTRO do painel, logo abaixo do
               botao de comprar. Ele nasce como irmao do conteudo (renderizado
               no card), e ficando de fora ele era ancorado no rodape: quando a
               lista de patches abria, o botao de comprar descia e sumia
               enquanto o azul continuava colado embaixo. Juntos no mesmo
               fluxo, os dois descem igual. O metodo hide() devolve o link pro
               lugar de origem antes de limpar o conteudo. */
            const linkDetalhes = this.querySelector('.cdr-quick-view-details-link');
            const blocoCompra = this.modalContent.querySelector('.cdr-buy-buttons-block');
            if (linkDetalhes && blocoCompra) {
              if (!this.linkDetalhesPaiOriginal) this.linkDetalhesPaiOriginal = linkDetalhes.parentElement;
              blocoCompra.insertAdjacentElement('afterend', linkDetalhes);
            }

            if (window.Shopify && Shopify.PaymentButton) {
              Shopify.PaymentButton.init();
            }
            if (window.ProductModel) window.ProductModel.loadShopifyXR();

            super.show(opener);
          })
          .finally(() => {
            opener.removeAttribute('aria-disabled');
            opener.classList.remove('loading');
            if (spinner) spinner.classList.add('hidden');
          });
      }

      preprocessHTML(productElement) {
        productElement.classList.forEach((classApplied) => {
          if (classApplied.startsWith('color-') || classApplied === 'gradient')
            this.modalContent.classList.add(classApplied);
        });
        this.preventDuplicatedIDs(productElement);
        this.removeDOMElements(productElement);
        this.removeGalleryListSemantic(productElement);
        this.updateImageSizes(productElement);
        this.preventVariantURLSwitching(productElement);
      }

      preventVariantURLSwitching(productElement) {
        productElement.setAttribute('data-update-url', 'false');
      }

      removeDOMElements(productElement) {
        const pickupAvailability = productElement.querySelector('pickup-availability');
        if (pickupAvailability) pickupAvailability.remove();

        const productModal = productElement.querySelector('product-modal');
        if (productModal) productModal.remove();

        const modalDialog = productElement.querySelectorAll('modal-dialog');
        if (modalDialog) modalDialog.forEach((modal) => modal.remove());
      }

      preventDuplicatedIDs(productElement) {
        const sectionId = productElement.dataset.section;

        const oldId = sectionId;
        const newId = `quickadd-${sectionId}`;
        productElement.innerHTML = productElement.innerHTML.replaceAll(oldId, newId);
        Array.from(productElement.attributes).forEach((attribute) => {
          if (attribute.value.includes(oldId)) {
            productElement.setAttribute(attribute.name, attribute.value.replace(oldId, newId));
          }
        });

        productElement.dataset.originalSection = sectionId;
      }

      removeGalleryListSemantic(productElement) {
        const galleryList = productElement.querySelector('[id^="Slider-Gallery"]');
        if (!galleryList) return;

        galleryList.setAttribute('role', 'presentation');
        galleryList.querySelectorAll('[id^="Slide-"]').forEach((li) => li.setAttribute('role', 'presentation'));
      }

      updateImageSizes(productElement) {
        const product = productElement.querySelector('.product');
        const desktopColumns = product?.classList.contains('product--columns');
        if (!desktopColumns) return;

        const mediaImages = product.querySelectorAll('.product__media img');
        if (!mediaImages.length) return;

        let mediaImageSizes =
          '(min-width: 1000px) 715px, (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw - 4rem)';

        if (product.classList.contains('product--medium')) {
          mediaImageSizes = mediaImageSizes.replace('715px', '605px');
        } else if (product.classList.contains('product--small')) {
          mediaImageSizes = mediaImageSizes.replace('715px', '495px');
        }

        mediaImages.forEach((img) => img.setAttribute('sizes', mediaImageSizes));
      }
    }
  );
}
